import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// -----------------------------------------------------------

Logo.propTypes = {
	disabledLink: PropTypes.bool,
	sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
	const theme = useTheme();
	const PRIMARY_LIGHT = theme.palette.primary.light;
	const PRIMARY_MAIN = theme.palette.primary.main;
	const PRIMARY_DARK = theme.palette.primary.dark;
	const logo = (
		<Box sx={{ width: 40, height: 40, ...sx }}>
			<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 1051.000000 1050.000000" >
				<defs>
					<linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
						<stop offset="0%" stopColor={PRIMARY_DARK} />
						<stop offset="100%" stopColor={PRIMARY_MAIN} />
					</linearGradient>
					<linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
						<stop offset="0%" stopColor={PRIMARY_LIGHT} />
						<stop offset="100%" stopColor={PRIMARY_MAIN} />
					</linearGradient>
					<linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
						<stop offset="0%" stopColor={PRIMARY_LIGHT} />
						<stop offset="100%" stopColor={PRIMARY_MAIN} />
					</linearGradient>
				</defs>
				<g
					fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd"  transform="translate(0.000000,1050.000000) scale(0.100000,-0.100000)" >
<path d="M3490 5935 c-281 -52 -477 -195 -526 -385 -33 -131 9 -256 124 -369
73 -71 210 -148 273 -153 l34 -3 5 275 5 275 126 3 127 3 6 31 c8 39 6 217 -2
283 l-7 50 -45 2 c-25 1 -79 -5 -120 -12z"/>
<path d="M3935 5938 c-3 -7 -6 -132 -7 -278 l-3 -265 -125 -5 -125 -5 -8 -60
c-5 -33 -5 -123 -2 -200 4 -77 7 -147 7 -156 0 -9 -26 -59 -56 -112 -31 -53
-56 -107 -56 -119 0 -16 28 -50 85 -106 l86 -83 172 7 c95 4 183 10 197 14 35
9 39 47 7 74 -13 12 -102 86 -196 166 -140 119 -171 150 -171 171 0 27 32 49
71 49 44 0 178 33 241 60 183 78 281 181 314 328 14 64 15 86 5 140 -22 121
-90 217 -209 296 -64 42 -181 96 -209 96 -8 0 -16 -6 -18 -12z"/>
<path d="M7087 5583 c-4 -3 -7 -154 -7 -335 l0 -328 55 0 c52 0 55 1 55 25 l0
25 55 -31 c49 -28 63 -31 115 -27 122 9 195 98 195 237 0 97 -30 162 -93 206
-39 27 -52 30 -115 30 -59 0 -78 -4 -104 -22 -17 -13 -34 -23 -37 -23 -3 0 -6
56 -6 125 l0 125 -53 0 c-30 0 -57 -3 -60 -7z m302 -309 c68 -48 68 -200 -1
-248 -30 -21 -93 -20 -129 1 -78 46 -79 182 -3 242 33 26 100 28 133 5z"/>
<path d="M4760 5247 l0 -325 51 -4 c28 -1 53 1 56 5 3 4 6 61 6 125 l2 117 49
6 49 5 32 -50 c17 -28 51 -86 75 -128 l44 -78 63 0 c35 0 63 3 63 8 0 4 -31
59 -70 122 -38 63 -70 120 -70 125 0 6 20 21 45 34 63 33 100 108 92 186 -7
65 -35 107 -97 143 -43 26 -52 27 -217 30 l-173 4 0 -325z m302 223 c49 -14
68 -43 68 -103 0 -84 -53 -113 -195 -105 l-60 3 -3 85 c-4 131 -5 130 81 130
39 0 89 -5 109 -10z"/>
<path d="M5542 5380 c-46 -11 -103 -59 -126 -106 -12 -24 -21 -67 -24 -112 -4
-63 -1 -79 23 -127 38 -79 95 -116 186 -123 84 -6 138 12 192 64 20 20 37 40
37 44 0 4 -18 15 -41 24 -40 16 -41 16 -70 -8 -33 -28 -102 -42 -139 -28 -31
12 -67 51 -72 77 -3 19 3 20 165 23 l167 2 0 48 c0 77 -18 123 -66 169 -60 58
-137 76 -232 53z m139 -103 c22 -14 43 -51 37 -68 -3 -8 -34 -12 -106 -13 -88
-1 -102 1 -102 15 0 22 38 69 64 80 24 10 80 3 107 -14z"/>
<path d="M6065 5375 c-61 -22 -95 -65 -95 -123 0 -78 34 -108 167 -147 95 -28
120 -71 56 -96 -41 -16 -94 -4 -121 26 -21 25 -25 26 -60 14 -54 -17 -54 -17
-30 -60 30 -53 85 -79 169 -79 109 1 173 42 186 122 11 70 -39 124 -142 153
-82 24 -115 42 -115 64 0 47 77 67 122 32 21 -17 30 -18 66 -9 48 12 52 25 17
62 -50 54 -137 70 -220 41z"/>
<path d="M6480 5227 c0 -171 12 -227 58 -269 54 -50 152 -63 210 -28 39 24 52
25 52 4 0 -12 10 -14 53 -12 l52 3 3 228 3 227 -60 0 -61 0 0 -150 c0 -88 -5
-159 -11 -173 -16 -34 -48 -49 -99 -45 -34 2 -48 9 -64 31 -19 25 -21 45 -25
183 l-3 154 -54 0 -54 0 0 -153z"/>
</g>
</svg>


		</Box >
	);
	if (disabledLink) {
		return <>{logo}</>;
	}

	return <RouterLink to="">{logo}</RouterLink>;
}
